var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.527,
    height: 47.527,
    viewBox: "0 0 47.527 47.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "encounter-icon",
    transform: "translate(-76.973 -414.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 76.973, 420.682)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 29,
    height: 40,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    transform: "translate(93.505 414.236) rotate(1)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 29,
    height: 40,
    rx: 4,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.b28808db66197f6d782cdc451673e368.svg";
export { ForwardRef as ReactComponent };